import React from 'react';
import { Card, Col, Flex, Row, Statistic } from 'antd';
import dayjs from 'dayjs';
import RangePicker from 'components/date-range-picker';
import TopProduct from './TopProduct';
import TopProductInCart from './TopProductInCart';

const ProductStatisticMobile = ({ viewModel }) => {
  const { data, filter, onDateRangeFilterChange } = viewModel;

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Flex justify='flex-end'>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <RangePicker
              format='DD/MM/YY'
              value={filter.range ? [dayjs(filter.range.start), dayjs(filter.range.end)] : null}
              onChange={onDateRangeFilterChange}
            />
          </div>
        </Flex>
      </Col>

      <Col span={8}>
        <Card>
          <Statistic title='Lượt xem' value={data.views} />
        </Card>
      </Col>
      <Col span={8}>
        <Card>
          <Statistic title='Khách hàng' value={data.customers} />
        </Card>
      </Col>
      <Col span={8}>
        <Card>
          <Statistic title='Đơn hàng' value={data.orders} />
        </Card>
      </Col>

      <Col span={24}>
        <Card title='Top sản phẩm được xem '>
          <TopProduct />
        </Card>
      </Col>

      <Col span={24}>
        <Card title='Top sản phẩm trong giỏ hàng '>
          <TopProductInCart />
        </Card>
      </Col>
    </Row>
  );
};

export default ProductStatisticMobile;
